import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MessageUpdateModalUI from './MessageUpdateModalUI'

class MessageUpdateModalSF extends Component {
  constructor(props) {
    super(props)

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      messageContent: (props.message && props.message.message) || '',
      messageContentError: null,
      emailToList: [],
    }
  }

  render() {
    return (
      <MessageUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        onSubmit={this.onSubmit}
        onCancelClick={this.onUpdateMessageCancel}
        messageUpdateMode={this.props.messageUpdateMode}
        submitted={this.state.submitted}
        messageContent={this.state.messageContent}
        onMessageContentChange={(event) => this.setState({ messageContent: event.target.value })}
        messageContentError={this.state.messageContentError}
        setMessageContentError={(error) => this.setState({ messageContentError: error })}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.message) return
    if (prevProps.message && prevProps.message.messageApprovalId === this.props.message.messageApprovalId) return
    this.setState({
      messageContent: this.props.message.message || '',
      messageContentError: null,
      errorList: [],
      successMsg: null
    })
  }

  onUpdateMessageCancel = () => {
    this.props.onUpdateMessageCancel()
  }

  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    })

    RestApiUtils.put(
      this.props.context,
      `/api/su/messages/approvals/${this.props.message.messageApprovalId}`,
      this.onSubmitCallback,
      {
        messageContent: this.state.messageContent,
      }
    )
  }

  onSubmitCallback = (response) => {
    const responseErrors = (response && response.errorList) || []
    const errorList = responseErrors.map((error) => error.message)

    this.setState({
      successMsg: response ? response.success : null,
      errorList: errorList,
      submitted: false,
    })

    if (responseErrors.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onUpdateMessageCancel()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default MessageUpdateModalSF